import React from 'react';
import {useTranslation} from "react-i18next";
import Divider from "@material-ui/core/Divider";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from '@material-ui/icons/Close';
import Slide from "@material-ui/core/Slide";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TableHead from "@material-ui/core/TableHead";
import Table from "@material-ui/core/Table";
import withStyles from "@material-ui/core/styles/withStyles";
import {TableCell} from "@material-ui/core";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import StaticClassifierRepository from "../../../repositories/StaticClassifierRepository";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const LogDialog = ({list, onClose}) => {

	const {t}  = useTranslation();
    const classes = useStyles();
    const classifierRepository = new StaticClassifierRepository();

    const mapAuditEventType = (id) => {
        return classifierRepository.getAuditEventTypeNameById(id);
    }

	return (
	    <>
        {list &&
           <Dialog fullWidth={true} maxWidth={"lg"} open={true} onClose={onClose} TransitionComponent={Transition}>
            <AppBar className={classes.appBar}>
              <Toolbar>
                <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title}>
                    {t('Activity log')}
                </Typography>
              </Toolbar>
            </AppBar>
            <>
                <Card>
                    <CardContent>
                         <Table>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>{t('Event date')}</StyledTableCell>
                                    <StyledTableCell>{t('Action')}</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {list.map((row, index) => {
                                return (
                                   <TableRow key={index}>
                                        <StyledTableCell>{row.CreatedAt}</StyledTableCell>
                                        <StyledTableCell>{mapAuditEventType(row.AuditEvent)}{row.Message ? ' ' + row.Message : ''}</StyledTableCell>
                                    </TableRow>
                                );
                            })}
                            </TableBody>
                        </Table>
                    </CardContent>
                </Card>
               <Divider />
            </>
          </Dialog>}
        </>
	);
};

export default LogDialog;